<template>
  <div
    class="grid gap-x-8 gap-y-16 grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3"
  >
    <template
      v-for="(item, index) in props.items"
      :key="item.key || index"
    >
      <div
        class="flex flex-col gap-4"
      >
        <div
          class="flex mx-auto bg-primary rounded-lg aspect-square h-[5em] w-[5em]"
        >
          <font-awesome-icon
            class="m-auto text-[3em] text-white"
            :icon="item.icon"
          />
        </div>
        <p
          class="text-center w-2/3 mx-auto font-semibold text-slate-900"
        >
          {{ item.text }}
        </p>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Icon } from '~/utils/types'

const props = defineProps<{
  items: {
    key?: string
    icon: Icon
    text: string
  }[]
}>()
</script>
